import { useCustomViewDialogStore } from "csi/middleware/customView/CustomViewDialogStore";
import { CssGrid } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import css from "./NamesTab.module.css";

const NamesTab: FunctionComponent = observer(() => {
	const { namesStore: { children } } = useCustomViewDialogStore();
	return (
		<CssGrid
			className={css.grid}
			columns={1}
			dataCsiAutomation="NamesTab"
		>
			{ children}
		</CssGrid>
	);
});

export default NamesTab;
